import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoBox from 'components/InfoBox/InfoBox';
import { Info } from 'components/Text';
import VehicleDetailCard from 'components/VehicleDetailCard/VehicleDetailCard';
import useTransferTag from 'hooks/tags/useTransferTag';
import { mapGetObeDetailsResult } from 'utils/mapping/mapVehicles';
export default function FromTag({
  title
}) {
  const {
    t
  } = useTranslation();
  const {
    fromVehicle,
    isObeBeingMoved
  } = useTransferTag();
  const infoTitle = title || t('transfer_tag.belongs_to');
  return /*#__PURE__*/React.createElement(React.Fragment, null, fromVehicle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoBox, {
    mb: 2
  }, `${t('tag.tag_number')}: ${fromVehicle?.obeNumber}`), fromVehicle.registrationNumber && /*#__PURE__*/React.createElement(Info, null, infoTitle), /*#__PURE__*/React.createElement(VehicleDetailCard, {
    hasBorder: true,
    hasHelperText: true,
    showVehicleIcon: false,
    vehicle: mapGetObeDetailsResult(fromVehicle)
  }), isObeBeingMoved && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.is_being_moved'))));
}
FromTag.defaultProps = {
  title: ''
};